const PhoneNumberRegex = RegExp(/^[4,9]\d{7}/);
const EmailRegex = RegExp(/^[a-zæøåA-ZÆØÅ0-9._%+-]+@[a-zæøåA-ZÆØÅ0-9.-]+\.[a-zæøåA-ZÆØÅ]{2,63}$/);

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  return PhoneNumberRegex.test(phoneNumber);
};

export const isValidEmail = (email: string): boolean => {
  return EmailRegex.test(email);
};
